var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade modal-confirmRegister",
      attrs: {
        id: "editTourInfo",
        "data-keyboard": "false",
        "data-backdrop": "static"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "data-dismiss": "modal" }
              },
              [_vm._v("×")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "center-modal" }, [
              _c("div", { staticClass: "registerTourInfo" }, [
                _c("div", { staticClass: "box-heading" }, [
                  _c("div", { staticClass: "title-precheck-info" }, [
                    _vm._v(_vm._s(_vm.$t("tour.precheck.precheckTour")))
                  ]),
                  _vm._v(" "),
                  _vm._m(0)
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "box-body" }, [
                  _c("div", { staticClass: "body-tour" }, [
                    _c("div", { staticClass: "row-cnt" }, [
                      _c("label", { staticClass: "cnt-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.tour_number")))
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "cnt-item" }, [
                        _vm._v(
                          _vm._s(_vm.tourInfo.tour_number) +
                            "(" +
                            _vm._s(_vm.storageService.getCashName()) +
                            ")"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt" }, [
                      _c("div", { staticClass: "cnt-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.tour_name")))
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tourInfo.name,
                            expression: "tourInfo.name"
                          }
                        ],
                        staticClass: "cnt-item",
                        style: {
                          "background-color":
                            _vm.errorTourName == true ? "pink" : "white"
                        },
                        attrs: { name: "tourName" },
                        domProps: { value: _vm.tourInfo.name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.tourInfo, "name", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt" }, [
                      _c("div", { staticClass: "cnt-side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.departure_date")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cnt-side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.return_date")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt" }, [
                      _c(
                        "div",
                        {
                          staticClass: "cnt-side-item",
                          style: {
                            border: _vm.errorDepartureDate
                              ? "solid 2px red"
                              : "none"
                          }
                        },
                        [
                          _c("date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              name: "departureDate",
                              format: "YY/MM/DD",
                              editable: false
                            },
                            model: {
                              value: _vm.tourInfo.departure_date,
                              callback: function($$v) {
                                _vm.$set(_vm.tourInfo, "departure_date", $$v)
                              },
                              expression: "tourInfo.departure_date"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cnt-side-item",
                          style: {
                            border: _vm.errorReturnDate
                              ? "solid 2px red"
                              : "none"
                          }
                        },
                        [
                          _c("date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              name: "returnDate",
                              format: "YY/MM/DD",
                              editable: false
                            },
                            model: {
                              value: _vm.tourInfo.return_date,
                              callback: function($$v) {
                                _vm.$set(_vm.tourInfo, "return_date", $$v)
                              },
                              expression: "tourInfo.return_date"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt" }, [
                      _c("div", { staticClass: "cnt-side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.person_count")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cnt-side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.conductor_number")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tourInfo.person_count,
                            expression: "tourInfo.person_count"
                          }
                        ],
                        ref: "person",
                        staticClass: "cnt-side-item text-num",
                        style: {
                          "background-color":
                            _vm.errorPersonCount || _vm.errorTotalNo
                              ? "pink"
                              : "white"
                        },
                        attrs: {
                          type: "text",
                          name: "personCount",
                          inputmode: "numeric",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.tourInfo.person_count },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.person.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.tourInfo,
                              "person_count",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.tourInfo.conductor_number,
                            expression: "tourInfo.conductor_number"
                          }
                        ],
                        ref: "conductor",
                        staticClass: "cnt-side-item text-num",
                        style: {
                          "background-color": _vm.errorConductorNumber
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          type: "text",
                          name: "conductorNumber",
                          inputmode: "numeric",
                          autocomplete: "off"
                        },
                        domProps: { value: _vm.tourInfo.conductor_number },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.conductor.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.tourInfo,
                              "conductor_number",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "body-teach-travel" }, [
                    _c("label", { staticClass: "title-teach-travel" }, [
                      _vm._v(_vm._s(_vm.$t("tour.precheck.areaTeachTravel")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt-just" }, [
                      _c("div", { staticClass: "side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.student")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.teacher")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.nurse")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.cameraman")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "side-title" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.other")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt-just" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.studentNo,
                            expression: "studentNo"
                          }
                        ],
                        ref: "student",
                        staticClass: "side-item text-num",
                        style: {
                          "background-color": _vm.errorTotalNo
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          name: "studentNo",
                          inputmode: "numeric",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.studentNo },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.student.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.studentNo = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.teacherNo,
                            expression: "teacherNo"
                          }
                        ],
                        ref: "teacher",
                        staticClass: "side-item text-num",
                        style: {
                          "background-color": _vm.errorTotalNo
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          name: "teacherNo",
                          inputmode: "numeric",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.teacherNo },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.teacher.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.teacherNo = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.nurseNo,
                            expression: "nurseNo"
                          }
                        ],
                        ref: "nurse",
                        staticClass: "side-item text-num",
                        style: {
                          "background-color": _vm.errorTotalNo
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          name: "nurseNo",
                          inputmode: "numeric",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.nurseNo },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.nurse.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nurseNo = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.cameraNo,
                            expression: "cameraNo"
                          }
                        ],
                        ref: "camera",
                        staticClass: "side-item text-num",
                        style: {
                          "background-color": _vm.errorTotalNo
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          name: "cameraNo",
                          inputmode: "numeric",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.cameraNo },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.camera.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.cameraNo = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.otherNo,
                            expression: "otherNo"
                          }
                        ],
                        ref: "other",
                        staticClass: "side-item text-num",
                        style: {
                          "background-color": _vm.errorTotalNo
                            ? "pink"
                            : "white"
                        },
                        attrs: {
                          name: "otherNo",
                          inputmode: "numeric",
                          autocomplete: "off",
                          type: "text"
                        },
                        domProps: { value: _vm.otherNo },
                        on: {
                          focus: function($event) {
                            return _vm.$refs.other.select()
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.otherNo = $event.target.value
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row-cnt-right" }, [
                      _c("label", { staticClass: "cnt-item" }, [
                        _vm._v(_vm._s(_vm.$t("tour.precheck.total")))
                      ]),
                      _vm._v(" "),
                      _vm.showTotalNo
                        ? _c("label", { staticClass: "cnt-item" }, [
                            _vm._v(_vm._s(_vm.totalNo))
                          ])
                        : _vm._e()
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mt-4 no-gutters" }, [
                _c("div", { staticClass: "col-6 pr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-pink-44 w-100 ex-orange-light",
                      on: { click: _vm.nextOfficialRegistration }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.next")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 pl-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-gray-44 w-100",
                      attrs: { "data-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.cancel")))]
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticStyle: { "font-size": "12px" } }, [
      _vm._v("収支明細に記載される情報を確認してください。"),
      _c("br"),
      _vm._v("下見などで内容が異なる場合は訂正してください。")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-395b974e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395b974e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/sp/Voucher/EditTourInfoModal.vue
// module id = null
// module chunks = 